import api from "./api";

const machineService = {
  getMachines: (params) => api.get("/machines", { params }),
  getMachine: (id) => api.get(`/machines/${id}`),

  getCategories: () => api.get("/categories"),

  getSubCategories: (categoryId) =>
    api.get(`/categories/sub-categories`, { params: { category: categoryId } }),

  createSubCategory: (data) => api.post("/categories/subcategories", data),

  checkAvailability: (id, data) =>
    api.post(`/machines/${id}/check-availability`, data),

  getFeaturedMachines: () => api.get("/machines/featured"),
};

export default machineService;
